import { IAssignedRoles, IOpenedFormHistoryInfo, IUserRoleActivity } from "@multiweb/types/contracts";
import { RequestContext } from "@multiweb/types/multiweb";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";
import { IRole } from "OW.Remoting/Remoting/IRolesAndICompetences";

/**
 * Klient poskytující přístup uloženými předvolbami uživateli
 * Týká se hlavně dočasně uložených informací
 * Umožňuje práci s profilem nebo historií formulářů
 * @includeToDoc
 */
export interface IUserSettingsClient {

    /**
     * Získá seznam posledních použitých formulářů přihlášeného uživatele
     * @param roles Role přidělené uživateli
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getOpenedFormsHistory(requestContext?: RequestContext): Promise<readonly IOpenedFormHistoryInfo[]>;

    /**
     * Uloží poslední otevřené formuláře
     * @param history Historie k uložení
     * @param roles Role přidělené uživateli
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     *
     */
    saveOpenedFormsHistory(history: readonly IOpenedFormHistoryInfo[], requestContext?: RequestContext): Promise<void>;

    /**
     * Ziská přidělené role bez aktivnosti
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getAssignedRoles(cancellationToken?: CancellationToken): Promise<IAssignedRoles>;

    /**
     * Uloží zaslané role v parametru
     * @param roles Role, které se mají uložit
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    saveActiveRoles(roles: readonly IUserRoleActivity[], cancellationToken: CancellationToken): Promise<void>;

    /**
     * Získá uložené role
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getActiveRoles(cancellationToken: CancellationToken): Promise<readonly IUserRoleActivity[] | null>;

    /**
     * Nastaví aktivní okruhy.
     * @param userRoles Role uživatele
     */
    setActiveUserRoleRanges(userRoles: IRole[]): Promise<void>;
}
